import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  AdminUser,
  Alert,
  anylitics,
  airporticon,
  ApplicationIcon,
  AtmCardIcon,
  Bookings,
  BusIcon,
  Content,
  CouponIcon,
  Customer,
  Dashboard,
  Dashboard2Icon,
  Flight,
  Hotel,
  InfluencerIcon,
  Inventory,
  Marketing,
  MobileIcon,
  Packages,
  Payment,
  PendingApprovals,
  Permissions,
  Rental,
  Report,
  Roles,
  Settelment,
  Setting,
  ShipIcon,
  Support,
  TrainIcon,
  Vendor,
  VideoIcon,
  Lock,
  VendorWhite,
  OtherManagement,
  AvtarManagement,
  BannerManagement,
  Subscription,
  AllVendor,
  WhiteShield,
  FileGray,
  Atmwhiteicon,
  Downarrow,
  Rightarrow,
  Downarrow2,
  PersonGray,
  Profile,
  Headset,
  AtmGray,
} from "../../assests/ExportImageIcon";
import "./sidebar.css";

const AdminSidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const handleClick = (name, route = null) => {
    if (route) navigate(route);
  };

  const handleDropdownClick = (name) => {
    if (collapsed) return;

    setOpenMenu((prev) => (prev === name ? null : name));
  };

  const isActive = (name) => {
    const path = location.pathname;

    switch (name) {
      case "dashboard":
        return path === "/dashboard" || path.startsWith("/dashboard/");

      case "vendor-management":
        return (
          path === "/all-vendor" ||
          path.startsWith("/all-vendor/") ||
          path === "/vendor-detail" ||
          path.startsWith("/vendor-detail/") ||
          path === "/venue-vendor" ||
          path.startsWith("/venue-vendor/") ||
          path === "/venue-detail" ||
          path.startsWith("/venue-detail/") ||
          path === "/venue-proposals" ||
          path.startsWith("/venue-proposals/") ||
          path === "/venue-proposal" ||
          path.startsWith("/venue-proposal/") ||
          path === "/bookings-venue" ||
          path.startsWith("/bookings-venue/") ||
          path === "/venue-booking-detail" ||
          path.startsWith("/venue-booking-detail/") ||
          path === "/event-vendor" ||
          path.startsWith("/event-vendor/") ||
          path === "/event-detail" ||
          path.startsWith("/event-detail/") ||
          path === "/event-coupon-detail" ||
          path.startsWith("/event-coupon-detail/") ||
          path === "/event-coupon-form" ||
          path.startsWith("/event-coupon-form/") ||
          path === "/bookings-event" ||
          path.startsWith("/bookings-event/") ||
          path === "/event-booking-detail" ||
          path.startsWith("/event-booking-detail/") ||
          path === "/hotel-vendor" ||
          path.startsWith("/hotel-vendor/") ||
          path === "/vendor-hotel-detail" ||
          path.startsWith("/vendor-hotel-detail/") ||
          path === "/hotel-booking-detail" ||
          path.startsWith("/hotel-booking-detail/") ||
          path === "/bookings-hotel" ||
          path.startsWith("/bookings-hotel/") ||
          path === "/create-listing" ||
          path.startsWith("/create-listing/") ||
          path === "/create-event" ||
          path.startsWith("/create-event/")
        );
      case "all-vendor":
        return (
          path === "/all-vendor" ||
          path.startsWith("/all-vendor/") ||
          path === "/vendor-detail" ||
          path.startsWith("/vendor-detail/")
        );
      case "venue-management":
        return (
          path === "/venue-vendor" ||
          path.startsWith("/venue-vendor/") ||
          path === "/venue-detail" ||
          path.startsWith("/venue-detail/") ||
          path === "/venue-proposals" ||
          path.startsWith("/venue-proposals/") ||
          path === "/venue-proposal" ||
          path.startsWith("/venue-proposal/") ||
          path === "/bookings-venue" ||
          path.startsWith("/bookings-venue/") ||
          path === "/venue-booking-detail" ||
          path.startsWith("/venue-booking-detail/") ||
          path === "/create-listing" ||
          path.startsWith("/create-listing/")
        );

      case "bookings":
        return (
          path === "/all-bookings" ||
          path.startsWith("/all-bookings/") ||
          path === "/flight" ||
          path.startsWith("/flight/") ||
          path === "/flight-detail" ||
          path.startsWith("/flight-detail/") ||
          path === "/hotel" ||
          path.startsWith("/hotel/") ||
          path === "/hotel-detail" ||
          path.startsWith("/hotel-detail/") ||
          path === "/packages" ||
          path.startsWith("/packages/") ||
          path === "/venue" ||
          path.startsWith("/venue/") ||
          path === "/venue-detail-view" ||
          path.startsWith("/venue-detail-view/") ||
          path === "/event" ||
          path.startsWith("/event/") ||
          path === "/event-detail-view" ||
          path.startsWith("/event-detail-view/") ||
          path === "/car-rental" ||
          path.startsWith("/car-rental/") ||
          path === "/car-rental-detail" ||
          path.startsWith("/car-rental-detail/") ||
          path === "/cruise" ||
          path.startsWith("/cruise/") ||
          path === "/cruise-detail" ||
          path.startsWith("/cruise-detail/") ||
          path === "/train" ||
          path.startsWith("/train/") ||
          path === "/domestic-train-detail" ||
          path.startsWith("/domestic-train-detail/") ||
          path === "/international-train-detail" ||
          path.startsWith("/international-train-detail/") ||
          path === "/bus" ||
          path.startsWith("/bus/") ||
          path === "/domestic-bus-detail" ||
          path.startsWith("/domestic-bus-detail/") ||
          path === "/international-bus-detail" ||
          path.startsWith("/international-bus-detail/") ||
          path === "/airport-lounge" ||
          path.startsWith("/airport-lounge/") ||
          path === "/airport-lounge-detail" ||
          path.startsWith("/airport-lounge-detail/") ||
          path === "/flight-lock" ||
          path.startsWith("/flight-lock/") ||
          path === "/add-configuration" ||
          path.startsWith("/add-configuration/")
        );

      case "Offers & Coupons":
        return (
          path === "/all-coupons" ||
          path.startsWith("/all-coupons/") ||
          path === "/flight-coupon" ||
          path.startsWith("/flight-coupon/") ||
          path === "/hotel-coupon" ||
          path.startsWith("/hotel-coupon/") ||
          path === "/bus-coupon" ||
          path.startsWith("/bus-coupon/") ||
          path === "/train-coupon" ||
          path.startsWith("/train-coupon/") ||
          path === "/cruise-coupon" ||
          path.startsWith("/cruise-coupon/") ||
          path === "/event-coupon" ||
          path.startsWith("/event-coupon/") ||
          path === "/car-rental-coupon" ||
          path.startsWith("/car-rental-coupon/") ||
          path === "/bank-offer" ||
          path.startsWith("/bank-offer/") ||
          path === "/airline-coupon" ||
          path.startsWith("/airline-coupon/") ||
          path === "/app-website-offer" ||
          path.startsWith("/app-website-offer/") ||
          path === "/coupon-analytics" ||
          path.startsWith("/coupon-analytics/")
        );

      case "Payment & Finance":
        return (
          path === "/payment" ||
          path.startsWith("/payment/") ||
          path === "/refund" ||
          path.startsWith("/refund/") ||
          path === "/refund-detail" ||
          path.startsWith("/refund-detail/") ||
          path === "/settlement" ||
          path.startsWith("/settlement/") ||
          path === "/settlement-detail" ||
          path.startsWith("/settlement-detail/") ||
          path === "/revenue" ||
          path.startsWith("/revenue/")
        );

      case "Influencer Management":
        return (
          path === "/influencer-dashboard" ||
          path.startsWith("/influencer-dashboard/") ||
          path === "/influencer-application" ||
          path.startsWith("/influencer-application/") ||
          path === "/influencer-application-detail" ||
          path.startsWith("/influencer-application-detail/") ||
          path === "/video-moderation" ||
          path.startsWith("/video-moderation/")
        );

      case "Others Management":
        return (
          path === "/avatar-management" ||
          path.startsWith("/avatar-management/") ||
          path === "/banner-management" ||
          path.startsWith("/banner-management/")
        );

      case "Subscription Management":
        return (
          path === "/subscription-plans" ||
          path.startsWith("/subscription-plans/") ||
          path === "/subscription-plans-detail" ||
          path.startsWith("/subscription-plans-detail/") ||
          path === "/subscription-plans-create" ||
          path.startsWith("/subscription-plans-create/") ||
          path === "/subscribers" ||
          path.startsWith("/subscribers/") ||
          path === "/subscribers-detail" ||
          path.startsWith("/subscribers-detail/")
        );

      case "Blog Management":
        return (
          path === "/all-blogs" ||
          path.startsWith("/all-blogs/") ||
          path === "/blogs-detail" ||
          path.startsWith("/blogs-detail/") ||
          path === "/create-blog" ||
          path.startsWith("/create-blog/") ||
          path === "/blog-authors" ||
          path.startsWith("/blog-authors/") ||
          path === "/blog-categories" ||
          path.startsWith("/blog-categories/")
        );

      case "all-vendor":
        return path === "/all-vendor" || path.startsWith("/all-vendor/");

      case "venue-list":
        return (
          path === "/venue-vendor" ||
          path.startsWith("/venue-vendor/") ||
          path === "/venue-detail" ||
          path.startsWith("/venue-detail/") ||
          path === "/bookings-venue" ||
          path.startsWith("/bookings-venue/") ||
          path === "/venue-booking-detail" ||
          path.startsWith("/venue-booking-detail/") ||
          path === "/create-listing" ||
          path.startsWith("/create-listing/")
        );

      case "venue-proposal":
        return (
          path === "/venue-proposals" ||
          path.startsWith("/venue-proposals/") ||
          path === "/venue-proposal" ||
          path.startsWith("/venue-proposal/")
        );

      case "event-vendor":
        return (
          path === "/event-vendor" ||
          path.startsWith("/event-vendor/") ||
          path === "/event-detail" ||
          path.startsWith("/event-detail/") ||
          path === "/event-coupon-detail" ||
          path.startsWith("/event-coupon-detail/") ||
          path === "/event-coupon-form" ||
          path.startsWith("/event-coupon-form/") ||
          path === "/bookings-event" ||
          path.startsWith("/bookings-event/") ||
          path === "/event-booking-detail" ||
          path.startsWith("/event-booking-detail/") ||
          path === "/create-event" ||
          path.startsWith("/create-event/")
        );

      case "hotel-vendor":
        return (
          path === "/hotel-vendor" ||
          path.startsWith("/hotel-vendor/") ||
          path === "/vendor-hotel-detail" ||
          path.startsWith("/vendor-hotel-detail/") ||
          path === "/hotel-booking-detail" ||
          path.startsWith("/hotel-booking-detail/") ||
          path === "/bookings-hotel" ||
          path.startsWith("/bookings-hotel/")
        );

      case "all-bookings":
        return path === "/all-bookings" || path.startsWith("/all-bookings/");

      case "flights":
        return (
          path === "/flight" ||
          path.startsWith("/flight/") ||
          path === "/flight-detail" ||
          path.startsWith("/flight-detail/")
        );

      case "hotels":
        return (
          path === "/hotel" ||
          path.startsWith("/hotel/") ||
          path === "/hotel-detail" ||
          path.startsWith("/hotel-detail/")
        );

      case "packages":
        return path === "/packages" || path.startsWith("/packages/");

      case "venue":
        return (
          path === "/venue" ||
          path.startsWith("/venue/") ||
          path === "/venue-detail-view" ||
          path.startsWith("/venue-detail-view/")
        );

      case "events":
        return (
          path === "/event" ||
          path.startsWith("/event/") ||
          path === "/event-detail-view" ||
          path.startsWith("/event-detail-view/")
        );

      case "rentals":
        return (
          path === "/car-rental" ||
          path.startsWith("/car-rental/") ||
          path === "/car-rental-detail" ||
          path.startsWith("/car-rental-detail/")
        );

      case "cruises":
        return (
          path === "/cruise" ||
          path.startsWith("/cruise/") ||
          path === "/cruise-detail" ||
          path.startsWith("/cruise-detail/")
        );

      case "trains":
        return (
          path === "/train" ||
          path.startsWith("/train/") ||
          path === "/domestic-train-detail" ||
          path.startsWith("/domestic-train-detail/") ||
          path === "/international-train-detail" ||
          path.startsWith("/international-train-detail/")
        );

      case "bus":
        return (
          path === "/bus" ||
          path.startsWith("/bus/") ||
          path === "/domestic-bus-detail" ||
          path.startsWith("/domestic-bus-detail/") ||
          path === "/international-bus-detail" ||
          path.startsWith("/international-bus-detail/")
        );

      case "airportlounge":
        return (
          path === "/airport-lounge" ||
          path.startsWith("/airport-lounge/") ||
          path === "/airport-lounge-detail" ||
          path.startsWith("/airport-lounge-detail/")
        );

      case "flightlock":
        return (
          path === "/flight-lock" ||
          path.startsWith("/flight-lock/") ||
          path === "/add-configuration" ||
          path.startsWith("/add-configuration/")
        );

      case "all-coupon":
        return path === "/all-coupons" || path.startsWith("/all-coupons/");

      case "flight-coupon":
        return path === "/flight-coupon" || path.startsWith("/flight-coupon/");

      case "hotel-coupon":
        return path === "/hotel-coupon" || path.startsWith("/hotel-coupon/");

      case "bus-coupon":
        return path === "/bus-coupon" || path.startsWith("/bus-coupon/");

      case "train-coupon":
        return path === "/train-coupon" || path.startsWith("/train-coupon/");

      case "cruise-coupon":
        return path === "/cruise-coupon" || path.startsWith("/cruise-coupon/");

      case "event-coupon":
        return path === "/event-coupon" || path.startsWith("/event-coupon/");

      case "rental-coupon":
        return (
          path === "/car-rental-coupon" ||
          path.startsWith("/car-rental-coupon/")
        );

      case "bank-coupon":
        return path === "/bank-offer" || path.startsWith("/bank-offer/");

      case "airline-coupon":
        return (
          path === "/airline-coupon" || path.startsWith("/airline-coupon/")
        );

      case "app-website-coupon":
        return (
          path === "/app-website-offer" ||
          path.startsWith("/app-website-offer/")
        );

      case "coupon-analytics":
        return (
          path === "/coupon-analytics" || path.startsWith("/coupon-analytics/")
        );

      case "payment":
        return path === "/payment" || path.startsWith("/payment/");

      case "refund":
        return (
          path === "/refund" ||
          path.startsWith("/refund/") ||
          path === "/refund-detail" ||
          path.startsWith("/refund-detail/")
        );

      case "settlement":
        return (
          path === "/settlement" ||
          path.startsWith("/settlement/") ||
          path === "/settlement-detail" ||
          path.startsWith("/settlement-detail/")
        );

      case "revenue":
        return path === "/revenue" || path.startsWith("/revenue/");

      case "customers":
        return (
          path === "/usermanagement" ||
          path.startsWith("/usermanagement/") ||
          path === "/user-detail" ||
          path.startsWith("/user-detail/")
        );

      case "marketing":
        return path === "/marketing" || path.startsWith("/marketing/");

      case "content":
        return path === "/content" || path.startsWith("/content/");

      case "influencer-dashboard":
        return (
          path === "/influencer-dashboard" ||
          path.startsWith("/influencer-dashboard/")
        );

      case "influencer-application":
        return (
          path === "/influencer-application" ||
          path.startsWith("/influencer-application/") ||
          path === "/influencer-application-detail" ||
          path.startsWith("/influencer-application-detail/")
        );

      case "video-moderation":
        return (
          path === "/video-moderation" || path.startsWith("/video-moderation/")
        );

      case "alerts":
        return path === "/alerts" || path.startsWith("/alerts/");

      case "report":
        return path === "/report" || path.startsWith("/report/");

      case "support":
        return (
          path === "/support" ||
          path.startsWith("/support/") ||
          path === "/support-detail" ||
          path.startsWith("/support-detail/")
        );

      case "avatar-management":
        return (
          path === "/avatar-management" ||
          path.startsWith("/avatar-management/")
        );

      case "banner-management":
        return (
          path === "/banner-management" ||
          path.startsWith("/banner-management/")
        );

      case "subscription-plans":
        return (
          path === "/subscription-plans" ||
          path.startsWith("/subscription-plans/") ||
          path === "/subscription-plans-detail" ||
          path.startsWith("/subscription-plans-detail/") ||
          path === "/subscription-plans-create" ||
          path.startsWith("/subscription-plans-create/")
        );

      case "subscribers":
        return (
          path === "/subscribers" ||
          path.startsWith("/subscribers/") ||
          path === "/subscribers-detail" ||
          path.startsWith("/subscribers-detail/")
        );

      case "all-blogs":
        return (
          path === "/all-blogs" ||
          path.startsWith("/all-blogs/") ||
          path === "/blogs-detail" ||
          path.startsWith("/blogs-detail/") ||
          path === "/create-blog" ||
          path.startsWith("/create-blog/")
        );

      case "authors":
        return path === "/blog-authors" || path.startsWith("/blog-authors/");

      case "categories":
        return (
          path === "/blog-categories" || path.startsWith("/blog-categories/")
        );

      case "settings":
        return path === "/settings" || path.startsWith("/settings/");

      case "requests":
        return path === "/requests" || path.startsWith("/requests/");

      case "Package Management":
        return (
          path === "/all-packages" ||
          path.startsWith("/all-packages/") ||
          path === "/my-packages" ||
          path.startsWith("/my-packages/") ||
          path === "/package-detail" ||
          path.startsWith("/package-detail/") ||
          path === "/package-categories" ||
          path.startsWith("/package-categories/") ||
          path === "/package-vendors" ||
          path.startsWith("/package-vendors/") ||
          path === "/create-package" ||
          path.startsWith("/create-package/") ||
          path === "/create-holiday-package" ||
          path.startsWith("/create-holiday-package/") ||
          path === "/holiday-packages-detail" ||
          path.startsWith("/holiday-packages-detail/")
        );

      case "all-packages":
        return (
          path === "/all-packages" ||
          path.startsWith("/all-packages/") ||
          path === "/package-detail" ||
          path.startsWith("/package-detail/") ||
          path === "/create-package" ||
          path.startsWith("/create-package/")
        );
      case "my-packages":
        return (
          path === "/my-packages" ||
          path.startsWith("/my-packages/") ||
          path === "/create-holiday-package" ||
          path.startsWith("/create-holiday-package/") ||
          path === "/holiday-packages-detail" ||
          path.startsWith("/holiday-packages-detail/")
        );
      case "package-vendors":
        return (
          path === "/package-vendors" || path.startsWith("/package-vendors/")
        );

      case "package-categories":
        return (
          path === "/package-categories" ||
          path.startsWith("/package-categories/")
        );

      default:
        return false;
    }
  };
  const isOpen = (name) => openMenu === name;

  const handleSubDropdownClick = (name) => {
    if (collapsed) return;

    setOpenSubMenu((prev) => (prev === name ? null : name));
  };

  const isSubOpen = (name) => openSubMenu === name;

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div onClick={() => navigate("/dashboard")} className="logo">
        <img
          src={require("../../assests/svg/logo.webp")}
          alt="Travel Booking"
          style={{
            maxHeight: "48px",
            maxWidth: "100%",
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
      </div>

      <ul className="menu">
        <li className="menu-item">
          <div
            className={`menu-link ${isActive("dashboard") ? "active" : ""}`}
            onClick={() => handleClick("dashboard", "/dashboard")}
          >
            <img src={Dashboard} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Dashboard</span>}
          </div>
        </li>
        {/* Roles & Permissions */}
        {/* <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isActive("roles") ? "active" : ""}`}
            onClick={() => handleDropdownClick("roles")}
            style={{ cursor: "pointer" }}
          >
            <img src={Roles} className="menu-icon-img" alt="" />
            {!collapsed && (
              <>
                <span className="menu-text">Roles & Permissions</span>
                <span className="ms-auto">
                  {isOpen("roles") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>
          {!collapsed && isOpen("roles") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("manage-roles", "/manage-roles")}
                className={isActive("manage-roles") ? "active" : ""}
              >
                <img src={Roles} className="menu-icon-img" alt="" />
                <span className="menu-text">Manage Roles</span>
              </li>
              <li
                onClick={() => handleClick("admin-users")}
                className={isActive("admin-users") ? "active" : ""}
              >
                <img src={AdminUser} className="menu-icon-img" alt="" />
                <span className="menu-text">Admin Users</span>
              </li>
              <li
                onClick={() => handleClick("permissions")}
                className={isActive("permissions") ? "active" : ""}
              >
                <img src={Permissions} className="menu-icon-img" alt="" />
                <span className="menu-text">Permissions</span>
              </li>
            </ul>
          )}
        </li> */}

        {/* Vendor Management */}
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${
              isActive("vendor-management") ? "active" : ""
            }`}
            onClick={() => handleDropdownClick("vendor-management")}
            style={{ cursor: "pointer" }}
          >
            <img src={VendorWhite} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">Vendor Management</span>

                <span className="ms-auto">
                  {isOpen("vendor-management") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("vendor-management") && (
            <ul className="submenu">
              {/* All Vendor */}
              <li
                onClick={() => handleClick("all-vendor", "/all-vendor")}
                className={isActive("all-vendor") ? "active" : ""}
              >
                <img src={AllVendor} className="menu-icon-img" alt="" />
                <span className="menu-text">All Vendor</span>
              </li>

              {/* Venue Dropdown */}
              <li className="menu-item showdrpdown">
                <div
                  className={`menu-link ${
                    isActive("venue-management") ? "active" : ""
                  }`}
                  onClick={() => handleSubDropdownClick("venue-management")}
                  style={{ cursor: "pointer" }}
                >
                  <img src={VendorWhite} className="menu-icon-img" alt="" />

                  <span className="menu-text">Venue</span>

                  <span className="ms-auto">
                    {isSubOpen("venue-management") ? (
                      <img src={Downarrow2} alt="" />
                    ) : (
                      <img src={Rightarrow} alt="" />
                    )}
                  </span>
                </div>

                {isSubOpen("venue-management") && (
                  <ul className="submenu">
                    {/* Existing Venue List */}
                    <li
                      onClick={() => handleClick("venue-list", "/venue-vendor")}
                      className={isActive("venue-list") ? "active" : ""}
                    >
                      <img src={VendorWhite} className="menu-icon-img" alt="" />
                      <span className="menu-text">List</span>
                    </li>

                    {/* Venue Proposal */}
                    <li
                      onClick={() =>
                        handleClick("venue-proposal", "/venue-proposals")
                      }
                      className={isActive("venue-proposal") ? "active" : ""}
                    >
                      <img src={Content} className="menu-icon-img" alt="" />
                      <span className="menu-text">Proposal</span>
                    </li>
                  </ul>
                )}
              </li>

              {/* Event */}
              <li
                onClick={() => handleClick("event-vendor", "/event-vendor")}
                className={isActive("event-vendor") ? "active" : ""}
              >
                <img src={Content} className="menu-icon-img" alt="" />
                <span className="menu-text">Event</span>
              </li>

              {/* Hotel */}
              <li
                onClick={() => handleClick("hotel-vendor", "/hotel-vendor")}
                className={isActive("hotel-vendor") ? "active" : ""}
              >
                <img src={WhiteShield} className="menu-icon-img" alt="" />
                <span className="menu-text">Hotel</span>
              </li>
            </ul>
          )}
        </li>

        {/* Package Management */}
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${
              isActive("Package Management") ? "active" : ""
            }`}
            onClick={() => handleDropdownClick("Package Management")}
            style={{ cursor: "pointer" }}
          >
            <img src={Packages} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">Package Management</span>

                <span className="ms-auto">
                  {isOpen("Package Management") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("Package Management") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("my-packages", "/my-packages")}
                className={isActive("my-packages") ? "active" : ""}
              >
                <img src={Packages} className="menu-icon-img" alt="" />
                <span className="menu-text">My Packages</span>
              </li>
              <li
                onClick={() => handleClick("all-packages", "/all-packages")}
                className={isActive("all-packages") ? "active" : ""}
              >
                <img src={Packages} className="menu-icon-img" alt="" />
                <span className="menu-text">All Packages</span>
              </li>
              <li
                onClick={() =>
                  handleClick("package-vendors", "/package-vendors")
                }
                className={isActive("package-vendors") ? "active" : ""}
              >
                <img src={Vendor} className="menu-icon-img" alt="" />
                <span className="menu-text">Vendors</span>
              </li>
              <li
                onClick={() =>
                  handleClick("package-categories", "/package-categories")
                }
                className={isActive("package-categories") ? "active" : ""}
              >
                <img src={FileGray} className="menu-icon-img" alt="" />
                <span className="menu-text">Categories</span>
              </li>
            </ul>
          )}
        </li>

        {/* Bookings */}
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isActive("bookings") ? "active" : ""}`}
            onClick={() => handleDropdownClick("bookings")}
            style={{ cursor: "pointer" }}
          >
            <img src={Bookings} className="menu-icon-img" alt="" />
            {!collapsed && (
              <>
                <span className="menu-text">Bookings</span>
                <span className="ms-auto">
                  {isOpen("bookings") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>
          {!collapsed && isOpen("bookings") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("all-bookings", "/all-bookings")}
                className={isActive("all-bookings") ? "active" : ""}
              >
                <img src={Bookings} className="menu-icon-img" alt="" />
                <span className="menu-text">All Booking</span>
              </li>
              <li
                onClick={() => handleClick("flights", "/flight")}
                className={isActive("flights") ? "active" : ""}
              >
                <img src={Flight} className="menu-icon-img" alt="" />
                <span className="menu-text">Flights</span>
              </li>
              <li
                onClick={() => handleClick("hotels", "/hotel")}
                className={isActive("hotels") ? "active" : ""}
              >
                <img src={Hotel} className="menu-icon-img" alt="" />
                <span className="menu-text">Hotels</span>
              </li>
              <li
                onClick={() => handleClick("packages", "/packages")}
                className={isActive("packages") ? "active" : ""}
              >
                <img src={Packages} className="menu-icon-img" alt="" />
                <span className="menu-text">Packages</span>
              </li>
              <li
                onClick={() => handleClick("venue", "/venue")}
                className={isActive("venue") ? "active" : ""}
              >
                <img src={AtmGray} className="menu-icon-img" alt="" />
                <span className="menu-text">Venue</span>
              </li>
              <li
                onClick={() => handleClick("events", "/event")}
                className={isActive("events") ? "active" : ""}
              >
                <img src={Bookings} className="menu-icon-img" alt="" />
                <span className="menu-text">Events</span>
              </li>
              <li
                onClick={() => handleClick("rentals", "/car-rental")}
                className={isActive("rentals") ? "active" : ""}
              >
                <img src={Rental} className="menu-icon-img" alt="" />
                <span className="menu-text">Car Rentals</span>
              </li>
              <li
                onClick={() => handleClick("cruises", "/cruise")}
                className={isActive("cruises") ? "active" : ""}
              >
                <img src={ShipIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Cruises</span>
              </li>
              <li
                onClick={() => handleClick("trains", "/train")}
                className={isActive("trains") ? "active" : ""}
              >
                <img src={TrainIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Trains</span>
              </li>
              <li
                onClick={() => handleClick("bus", "/bus")}
                className={isActive("bus") ? "active" : ""}
              >
                <img src={BusIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Bus</span>
              </li>
              <li
                onClick={() => handleClick("airportlounge", "/airport-lounge")}
                className={isActive("airportlounge") ? "active" : ""}
              >
                <img src={airporticon} className="menu-icon-img" alt="" />
                <span className="menu-text">Airport Lounge</span>
              </li>
              <li
                onClick={() => handleClick("flightlock", "/flight-lock")}
                className={isActive("flightlock") ? "active" : ""}
              >
                <img src={Lock} className="menu-icon-img" alt="" />
                <span className="menu-text">Flight Lock</span>
              </li>
            </ul>
          )}
        </li>
        {/* Offers & Coupons */}
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isActive("Offers & Coupons") ? "active" : ""}`}
            onClick={() => handleDropdownClick("Offers & Coupons")}
            style={{ cursor: "pointer" }}
          >
            <img src={Bookings} className="menu-icon-img" alt="" />
            {!collapsed && (
              <>
                <span className="menu-text">Offers & Coupons</span>
                <span className="ms-auto">
                  {isOpen("Offers & Coupons") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>
          {!collapsed && isOpen("Offers & Coupons") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("all-coupon", "/all-coupons")}
                className={isActive("all-coupon") ? "active" : ""}
              >
                <img src={CouponIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">All Coupons</span>
              </li>
              <li
                onClick={() => handleClick("flight-coupon", "/flight-coupon")}
                className={isActive("flight-coupon") ? "active" : ""}
              >
                <img src={Flight} className="menu-icon-img" alt="" />
                <span className="menu-text">Flights</span>
              </li>
              <li
                onClick={() => handleClick("hotel-coupon", "/hotel-coupon")}
                className={isActive("hotel-coupon") ? "active" : ""}
              >
                <img src={Hotel} className="menu-icon-img" alt="" />
                <span className="menu-text">Hotels</span>
              </li>
              <li
                onClick={() => handleClick("bus-coupon", "/bus-coupon")}
                className={isActive("bus-coupon") ? "active" : ""}
              >
                <img src={BusIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Bus</span>
              </li>
              <li
                onClick={() => handleClick("train-coupon", "/train-coupon")}
                className={isActive("train-coupon") ? "active" : ""}
              >
                <img src={TrainIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Train</span>
              </li>
              <li
                onClick={() => handleClick("cruise-coupon", "/cruise-coupon")}
                className={isActive("cruise-coupon") ? "active" : ""}
              >
                <img src={ShipIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Cruise</span>
              </li>
              <li
                onClick={() => handleClick("event-coupon", "/event-coupon")}
                className={isActive("event-coupon") ? "active" : ""}
              >
                <img src={Bookings} className="menu-icon-img" alt="" />
                <span className="menu-text">Events</span>
              </li>
              <li
                onClick={() =>
                  handleClick("rental-coupon", "/car-rental-coupon")
                }
                className={isActive("rental-coupon") ? "active" : ""}
              >
                <img src={Rental} className="menu-icon-img" alt="" />
                <span className="menu-text">Car Rentals</span>
              </li>
              <li
                onClick={() => handleClick("bank-coupon", "/bank-offer")}
                className={isActive("bank-coupon") ? "active" : ""}
              >
                <img src={AtmCardIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Bank Offers</span>
              </li>
              <li
                onClick={() => handleClick("airline-coupon", "/airline-coupon")}
                className={isActive("airline-coupon") ? "active" : ""}
              >
                <img src={Flight} className="menu-icon-img" alt="" />
                <span className="menu-text">Airline Offers</span>
              </li>
              <li
                onClick={() =>
                  handleClick("app-website-coupon", "/app-website-offer")
                }
                className={isActive("app-website-coupon") ? "active" : ""}
              >
                <img src={MobileIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">App & Website</span>
              </li>
              <li
                onClick={() =>
                  handleClick("coupon-analytics", "/coupon-analytics")
                }
                className={isActive("coupon-analytics") ? "active" : ""}
              >
                <img src={anylitics} className="menu-icon-img" alt="" />
                <span className="menu-text">Analytics</span>
              </li>
            </ul>
          )}
        </li>
        {/* Inventory Management */}
        {/* <li className="menu-item showdrpdown">
          <div className={`menu-link ${isActive("inventory") ? "active" : ""}`} onClick={() => handleDropdownClick("inventory")} style={{ cursor: "pointer" }}>
            <img src={Inventory} className="menu-icon-img" alt="" />
            {!collapsed && (
              <>
                <span className="menu-text">Inventory Management</span>
                <span className={`dropdown-arrow ms-auto ${isOpen("inventory") ? "rotate" : ""}`}>&#8964;</span>
              </>
            )}
          </div>
          {!collapsed && isOpen("inventory") && (
            <ul className="submenu">
              <li onClick={() => handleClick("inv-flights")} className={isActive("inv-flights") ? "active" : ""}>
                <img src={Flight} className="menu-icon-img" alt="" />
                <span className="menu-text">Flights</span>
              </li>
              <li onClick={() => handleClick("inv-hotels")} className={isActive("inv-hotels") ? "active" : ""}>
                <img src={Hotel} className="menu-icon-img" alt="" />
                <span className="menu-text">Hotels</span>
              </li>
              <li onClick={() => handleClick("inv-packages")} className={isActive("inv-packages") ? "active" : ""}>
                <img src={Packages} className="menu-icon-img" alt="" />
                <span className="menu-text">Packages</span>
              </li>
              <li onClick={() => handleClick("inv-events")} className={isActive("inv-events") ? "active" : ""}>
                <img src={Bookings} className="menu-icon-img" alt="" />
                <span className="menu-text">Events</span>
              </li>
            </ul>
          )}
        </li> */}
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${
              isActive("Payment & Finance") ? "active" : ""
            }`}
            onClick={() => handleDropdownClick("Payment & Finance")}
            style={{ cursor: "pointer" }}
          >
            <img src={Atmwhiteicon} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">Payment & Finance</span>
                <span className="ms-auto">
                  {isOpen("Payment & Finance") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("Payment & Finance") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("payment", "/payment")}
                className={isActive("payment") ? "active" : ""}
              >
                <img src={Bookings} className="menu-icon-img" alt="" />
                <span className="menu-text">Payment</span>
              </li>

              <li
                onClick={() => handleClick("refund", "/refund")}
                className={isActive("refund") ? "active" : ""}
              >
                <img src={AtmCardIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Refund</span>
              </li>
              <li
                onClick={() => handleClick("settlement", "/settlement")}
                className={isActive("settlement") ? "active" : ""}
              >
                <img src={anylitics} className="menu-icon-img" alt="" />
                <span className="menu-text">Settlements</span>
              </li>
              <li
                onClick={() => handleClick("revenue", "/revenue")}
                className={isActive("revenue") ? "active" : ""}
              >
                <img src={anylitics} className="menu-icon-img" alt="" />
                <span className="menu-text">Revenue Report</span>
              </li>
            </ul>
          )}
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${isActive("customers") ? "active" : ""}`}
            onClick={() => handleClick("customers", "/usermanagement")}
          >
            <img src={Customer} className="menu-icon-img" alt="" />
            {!collapsed && (
              <span className="menu-text">Customer Management</span>
            )}
          </div>
        </li>
        {/* <li className="menu-item">
          <div
            className={`menu-link ${isActive("marketing") ? "active" : ""}`}
            onClick={() => handleClick("marketing", "/marketing")}
          >
            <img src={Marketing} className="menu-icon-img" alt="" />
            {!collapsed && (
              <span className="menu-text">Marketing & Campaigns</span>
            )}
          </div>
        </li> */}
        {/* <li className="menu-item">
          <div
            className={`menu-link ${isActive("content") ? "active" : ""}`}
            onClick={() => handleClick("content", "/content")}
          >
            <img src={Content} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Content Workflow</span>}
          </div>
        </li> */}
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isActive("Influencer Management") ? "active" : ""}`}
            onClick={() => handleDropdownClick("Influencer Management")}
            style={{ cursor: "pointer" }}
          >
            <img src={InfluencerIcon} className="menu-icon-img" alt="" />
            {!collapsed && (
              <>
                <span className="menu-text">Influencer Management</span>
                <span className="ms-auto">
                  {isOpen("Influencer Management") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>
          {!collapsed && isOpen("Influencer Management") && (
            <ul className="submenu">
              <li
                onClick={() =>
                  handleClick("influencer-dashboard", "/influencer-dashboard")
                }
                className={isActive("influencer-dashboard") ? "active" : ""}
              >
                <img src={Dashboard2Icon} className="menu-icon-img" alt="" />
                <span className="menu-text">Dashboard</span>
              </li>
              <li
                onClick={() =>
                  handleClick(
                    "influencer-application",
                    "/influencer-application",
                  )
                }
                className={isActive("influencer-application") ? "active" : ""}
              >
                <img src={ApplicationIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Applications</span>
              </li>
              <li
                onClick={() =>
                  handleClick("video-moderation", "/video-moderation")
                }
                className={isActive("video-moderation") ? "active" : ""}
              >
                <img src={VideoIcon} className="menu-icon-img" alt="" />
                <span className="menu-text">Video Moderation</span>
              </li>
            </ul>
          )}
        </li>
        {/* <li className="menu-item">
          <div
            className={`menu-link ${isActive("alerts") ? "active" : ""}`}
            onClick={() => handleClick("alerts", "/alerts")}
          >
            <img src={Alert} className="menu-icon-img" alt="" />
            {!collapsed && (
              <span className="menu-text">Alerts & Monitoring</span>
            )}
          </div>
        </li> */}
        <li className="menu-item">
          <div
            className={`menu-link ${isActive("report") ? "active" : ""}`}
            onClick={() => handleClick("report", "/report")}
          >
            <img src={Report} className="menu-icon-img" alt="" />
            {!collapsed && (
              <span className="menu-text">Reports & Analytics</span>
            )}
          </div>
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${isActive("support") ? "active" : ""}`}
            onClick={() => handleClick("support", "/support")}
          >
            <img src={Support} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Support & Tickets</span>}
          </div>
        </li>
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isActive("Others Management") ? "active" : ""}`}
            onClick={() => handleDropdownClick("Others Management")}
            style={{ cursor: "pointer" }}
          >
            <img src={OtherManagement} className="menu-icon-img" alt="" />
            {!collapsed && (
              <>
                <span className="menu-text">Others Management</span>
                <span className="ms-auto">
                  {isOpen("Others Management") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>
          {!collapsed && isOpen("Others Management") && (
            <ul className="submenu">
              <li
                onClick={() =>
                  handleClick("avatar-management", "/avatar-management")
                }
                className={isActive("avatar-management") ? "active" : ""}
              >
                <img src={AvtarManagement} className="menu-icon-img" alt="" />
                <span className="menu-text">Avatar Management</span>
              </li>
              <li
                onClick={() =>
                  handleClick("banner-management", "/banner-management")
                }
                className={isActive("banner-management") ? "active" : ""}
              >
                <img src={BannerManagement} className="menu-icon-img" alt="" />
                <span className="menu-text">App Banner Management</span>
              </li>
            </ul>
          )}
        </li>
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${
              isActive("Subscription Management") ? "active" : ""
            }`}
            onClick={() => handleDropdownClick("Subscription Management")}
            style={{ cursor: "pointer" }}
          >
            <img src={Subscription} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">Subscription Management</span>

                <span className="ms-auto">
                  {isOpen("Subscription Management") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("Subscription Management") && (
            <ul className="submenu">
              <li
                onClick={() =>
                  handleClick("subscription-plans", "/subscription-plans")
                }
                className={isActive("subscription-plans") ? "active" : ""}
              >
                <img src={Subscription} className="menu-icon-img" alt="" />
                <span className="menu-text">Subscription Plans</span>
              </li>

              <li
                onClick={() => handleClick("subscribers", "/subscribers")}
                className={isActive("subscribers") ? "active" : ""}
              >
                <img src={Customer} className="menu-icon-img" alt="" />
                <span className="menu-text">Subscribers</span>
              </li>
            </ul>
          )}
        </li>
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${
              isActive("Blog Management") ? "active" : ""
            }`}
            onClick={() => handleDropdownClick("Blog Management")}
            style={{ cursor: "pointer" }}
          >
            <img src={FileGray} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">Blog Management</span>

                <span className="ms-auto">
                  {isOpen("Blog Management") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("Blog Management") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("all-blogs", "/all-blogs")}
                className={isActive("all-blogs") ? "active" : ""}
              >
                <img src={FileGray} className="menu-icon-img" alt="" />
                <span className="menu-text">All Blogs</span>
              </li>

              <li
                onClick={() => handleClick("authors", "/blog-authors")}
                className={isActive("authors") ? "active" : ""}
              >
                <img src={Profile} className="menu-icon-img" alt="" />
                <span className="menu-text">Authors</span>
              </li>

              <li
                onClick={() => handleClick("categories", "/blog-categories")}
                className={isActive("categories") ? "active" : ""}
              >
                <img src={FileGray} className="menu-icon-img" alt="" />
                <span className="menu-text">Categories</span>
              </li>
            </ul>
          )}
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${isActive("settings") ? "active" : ""}`}
            onClick={() => handleClick("settings", "/settings")}
          >
            <img src={Setting} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Settings</span>}
          </div>
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${isActive("requests") ? "active" : ""}`}
            onClick={() => handleClick("requests", "/requests")}
          >
            <img src={Headset} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text"> Support Requests</span>}
          </div>
        </li>
        {/* <li className="menu-item showdrpdown">
          <div className={`menu-link ${isActive("Vender") ? "active" : ""}`} onClick={() => handleDropdownClick("Vender")} style={{ cursor: "pointer" }}>
            <img src={Vendor} className="menu-icon-img" alt="" />
            {!collapsed && (
              <>
                <span className="menu-text">Vendor</span>
                <span className={`dropdown-arrow ms-auto ${isOpen("Vender") ? "rotate" : ""}`}>&#8964;</span>
              </>
            )}
          </div>
          {!collapsed && isOpen("Vender") && (
            <ul className="submenu">
              <li onClick={() => handleClick("vendor-dashboard", "/vendor-dashboard")} className={isActive("vendor-dashboard") ? "active" : ""}>
                <img src={Dashboard2Icon} className="menu-icon-img" alt="" />
                <span className="menu-text">Dashboard</span>
              </li>
              <li onClick={() => handleClick("vendor-my-listings", "/vendor-my-listings")} className={isActive("vendor-my-listings") ? "active" : ""}>
                <img src={Inventory} className="menu-icon-img" alt="" />
                <span className="menu-text">My Listings</span>
              </li>
                 <li onClick={() => handleClick("vendor-booking","/vendor-booking")} className={isActive("vendor-booking") ? "active" : ""}>
                <img src={Inventory} className="menu-icon-img" alt="" />
                <span className="menu-text">Bookings</span>
              </li>
                <li onClick={() => handleClick("proposal","/proposal")} className={isActive("proposal") ? "active" : ""}>
                <img src={Inventory} className="menu-icon-img" alt="" />
                <span className="menu-text">Proposals</span>
              </li>
               <li onClick={() => handleClick("negotiation","/negotiation")} className={isActive("negotiation") ? "active" : ""}>
                <img src={Inventory} className="menu-icon-img" alt="" />
                <span className="menu-text">Negotiation Chat</span>
              </li> 
                 <li onClick={() => handleClick("earning-payout","/earning-payout")} className={isActive("earning-payout") ? "active" : ""}>
                <img src={Inventory} className="menu-icon-img" alt="" />
                <span className="menu-text">Earnings</span>
              </li> 
                
            </ul>
          )}
        </li> */}
      </ul>
    </div>
  );
};

export default AdminSidebar;
